<!-- readyToDisplayPdf -->
<app-pdf-viewer *ngIf="readyToDisplayPdf"
    [statutCall]="'quotes'"
    [dataList]= "filesToDisplay"
    [otherData]= "otherData"
></app-pdf-viewer>